define('app-Agents/modules/header/module',["./settings"], function (settings) {
    var container = $(settings.container);

    if (container.length === 0) {
        return null;
    }

    return {
        initialise: function (globalSettings) {
            var agentInformationContainer = container.find(settings.information.container);

            agentInformationContainer.find(settings.information.text).on("click", function (e) {
                e.preventDefault();

                agentInformationContainer.toggleClass("active");
            });
        }
    }
});
